import Transition from './transition';

export default { Transition: Transition };


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/animate/index.js
// module id = 313
// module chunks = 0